<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import PickupsComponent from './component.pickups.svelte'
    import PickupComponent from './component.pickup.svelte'
    import PickupUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'TracingsView.Pickups.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Recolecciones" subtitle="Gestiona las recolecciones programadas" />
    <PickupsComponent />
</View>

<Modal id="pickup_modal" title="Recolección" >
    <PickupComponent />
</Modal>

<Modal id="pickup_update_modal" title="Recolección" >
    <PickupUpdateComponent />
</Modal>
